import React, { useEffect, useState } from "react";
import './../Home/HomeComponent.css';
import { Link, useNavigate, useParams } from "react-router-dom"
import MANALI from '../../assets/images/MANALI.jpg';
import HeaderComponent from "../../components/Header/Header";
import axios from "axios";
import { Backdrop, CircularProgress } from "@mui/material";
import toast, { Toaster } from 'react-hot-toast';
import 'react-datepicker/dist/react-datepicker.css';
import NewNavBar from "../../components/NewNavBar/NewNavBar";
import Sidebar from "../../components/Sidebar/Sidebar";
import environment from "../../environment/environment";
import Footer from "../../components/Footer/Footer";
import CustomSpinner from "../../components/CustomeSpinner/CustomeSpinner";
import SignIn from "../../components/SignInComponent/SignIn";
import UpcomingTrips from "../UpcomingTrips/UpcomingTrips";

function HomeComponent() {
  const navigate = useNavigate()
  const [productDetails, setProductDetails] = useState([]);
  const [isFormFixed, setIsFormFixed] = useState(false);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [travelDate, setTravelDate] = useState('');
  const [travelCount, setTravelCount] = useState('');
  const [message, setMessage] = useState('');
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [packageItemInfo, setPackageItemInfo] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(true);
  const { routeId } = useParams();
  const [coverImageDetails, setCoverImageDetails] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isModelSign, setIsModelSign] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0)
    getAllRoute();
    getAllRouteById();

  }, []);

  const getAllRoute = () => {
    setIsLoading(true)
    axios({
      url: `${environment.config.apiBaseUrl}route/getAllRoutePackages`,
      method: "GET",
      headers: {
        authorization: "your token comes here",
      },
    })
      .then((res) => {
        if (res && res.data) {
          setProductDetails(res.data);
          setTimeout(() => {
            setIsLoading(false);
          }, 1500);
        }
      })
      .catch((err) => { });
  }
  const handleCancel = () => {
    setEmail('')
    setErrors({})
    setFullName('')
    setMessage('')
    setMobileNo('')
    setTravelDate('')
    setTravelCount('')
  }

  const onPackageClick = (event, packaageItem) => {
    const data = {
      packaageInfo: packaageItem
    }

    navigate(`/package-details/:${packaageItem.packageUID}`);
  }
  const validateForm = () => {
    const newErrors = {};

    if (!fullName.trim()) newErrors.fullName = 'Full Name is required';

    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = 'Valid Email is required';
    }

    if (!mobileNo.trim()) {
      newErrors.mobileNo = 'Mobile No. is required';
    } else if (!/^\d{10}$/.test(mobileNo)) {
      newErrors.mobileNo = 'Mobile No. must be exactly 10 digits';
    }

    if (!travelDate) newErrors.travelDate = 'Travel Date is required';
    if (!travelCount) newErrors.travelCount = 'Traveller Count is required';
    if (!message.trim()) newErrors.message = 'Message is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (field, value) => {
    switch (field) {
      case 'fullName':
        setFullName(value);
        break;
      case 'email':
        setEmail(value);
        break;
      case 'mobileNo':
        setMobileNo(value);
        break;
      case 'travelDate':
        setTravelDate(value);
        break;
      case 'travelCount':
        setTravelCount(value);
        break;
      case 'message':
        setMessage(value);
        break;
      default:
        break;
    }
    if (errors[field]) {
      setErrors((prevErrors) => ({ ...prevErrors, [field]: '' }));
    }
  };

  const requestCallBack = (packaageItem) => {
    setPackageItemInfo(packaageItem)
    setErrors({})
  }


  const handleBookNow = (item, packageItem) => {
    const data = {
      packaageInfo: packageItem
    }
    navigate(`/package-details/:${packageItem.packageUID}`);
  }

  const sendEnquiry = () => {

    if (!validateForm()) {
      toast.error('Please Enter Valid Details To Connect With An Experts!')
      return;
    }
    const requestBody = {
      "fullName": fullName,
      "email": email,
      "phoneNumber": mobileNo,
      "travelDate": travelDate,
      "travellerCount": travelCount,
      "message": message,
      "type": "website"
    };
    setLoadingDetails(true);
    axios({
      url: `${environment.config.apiBaseUrl}enquiry/createEnquiryDeatils`,
      method: "POST",
      headers: {
        authorization: "your token comes here",
      },
      data: requestBody
    })
      .then((res) => {
        setLoadingDetails(false);
        if (res && res.data) {
          document.getElementById("exampleModal").classList.remove("show", "d-block");
          document.querySelectorAll(".modal-backdrop")
            .forEach(el => el.classList.remove("modal-backdrop"));
          toast.success('Your Equiry Details Added Successfully Our Team Will Contact You Soon!')

        }
      })
      .catch(() => { setLoadingDetails(false); });
    setFullName('');
    setEmail('');
    setMessage('');
    setTravelCount('');
    setTravelDate('');
    setMessage('');
    setMobileNo('');
  };
  useEffect(() => {
    const trip = document.getElementById('end-trip');
    const handleScroll = () => {
      if (window.scrollY >= 1500) {
        setIsFormFixed(true);
      } else {
        setIsFormFixed(false);

      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollHorizontally = (containerId, direction) => {
    const container = document.getElementById(containerId);
    if (container) {
      const scrollAmount = 300;
      const currentScrollPosition = container.scrollLeft;

      if (direction === 'left') {
        container.scrollTo({
          left: currentScrollPosition - scrollAmount,
          behavior: 'smooth'
        });
      } else {
        container.scrollTo({
          left: currentScrollPosition + scrollAmount,
          behavior: 'smooth'
        });
      }
    }
  };
  const getAllRouteById = () => {

    axios({
      url: `${environment.config.apiBaseUrl}package/getAllCoverImagesDetails`,
      method: "GET",
      headers: {
        authorization: "your token comes here",
      },
    })
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          const allPackageLists = res.data.flatMap(item => item.packageList || []);
          setCoverImageDetails(allPackageLists);
        }
      })
      .catch((err) => { });
  }

  const onSignInUser = (data) => {
    setUserDetails(data);
  }

  const handleClose = (data) => {
    if (!data) {
      setIsModelSign(false);
    }
  };

  const handleBookOnline = (packageItem) => {
    setIsLoading(true);
    axios({
      url: `${environment.config.apiBaseUrl}package/getTourPackage?packageUID=${packageItem.packageUID}`,
      method: "GET",
      headers: {
        authorization: "your token comes here",
      },
    }).then((res) => {
      const fetchedData = res.data[0];
      setPackageData(res.data[0]);
      let accessToken = localStorage.getItem("token")
      if (accessToken) {
        setTimeout(() => {
          setIsLoading(false);
          navigate('/booking', { state: { packageData: fetchedData } });
        })

      } else {
        setTimeout(() => {
          setIsLoading(false);
          setIsModelSign(true)
        })
      }

    })


  }

  return (
    <>
      <div className="stickyheader">
        <HeaderComponent></HeaderComponent>
        <NewNavBar className='newnavbartoggle' />
      </div>
      <Sidebar className='sidebartoggle' />
      {isLoading &&
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(0, 0, 0, 0.4)"
          }}
          open={isLoading}
        >
          <CustomSpinner color="inherit" />
        </Backdrop>
      }
      <>
        <Toaster
          position="top-right"
          reverseOrder={false}
        />
        <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-indicators indicator-tab">
            {coverImageDetails?.map((_, index) => (
              <button
                key={`indicator-${index}`}
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-label={`Slide ${index + 1}`}
                aria-current={index === 0 ? "true" : undefined}
              ></button>
            ))}
          </div>
          <div className="carousel-inner" >
            {coverImageDetails?.map((item, index) => (
              <div
                key={item.packageUID || index}
                className={`carousel-item cursorpointer ${index === 0 ? "active" : ""}`}
              >
                <div className="bannerimg-gradient-homepage" onClick={(event) => onPackageClick(event, item)}></div>
                <img
                  src={item.imageList[0].coverImage}
                  className="d-block w-100 bannerimg-height"
                  alt={item.packageName}
                  onError={(e) => (e.target.src = 'fallback-image.jpg')}
                />
                <div className="carousel-caption bannerimg-carousel-caption-text-homepage d-md-block">
                  <div className="cities-bannerimg-title-homepage" >
                    <div>{item.packageName}</div>
                  </div>
                  <div className="bannerimg-carousel_packageday__bannerimg_cities-homepage mt-1">
                    <div>{item.packageDays} days & {item.packageNight} nights | {item.packageDays}D {item.routeName}</div>
                  </div>
                  {/* <div className="bannerimg__divider_line-homepage"></div> */}
                  <div className="prices-homepage">
                    <b className="carousel_packageday__bannerimg_cities_prices-homepage me-2" style={{ color: '#fff099' }}>
                      INR {new Intl.NumberFormat('en-IN').format(item.packageWithDiscountPrices)}
                    </b>
                    <span className="bannerimg-carousel_packageday__bannerimg_cities_prices_discount-homepage">
                      INR {new Intl.NumberFormat('en-IN').format(item.packagePrices)}
                    </span>
                  </div>
                  {item.packageType === 'Price' ? (
                    <button
                      type="button"
                      className="btn btn-color"
                      style={{ backgroundColor: '#ffbc23', border: 'none', color: '#2d2b29', width: '200px', zIndex: 7 }}
                      onClick={() => handleBookOnline(item)}
                    >
                      Book Now
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-color"
                      style={{ backgroundColor: '#fff099', border: 'none', color: '#2d2b29', width: '200px', zIndex: 7 }}
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={() => requestCallBack(item)}
                    >
                      Request Callback
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          <button
            className="carousel-control-prev bannerimg-carousel-control-prev-homepage"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next bannerimg-carousel-control-next-homepage"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>

        <UpcomingTrips />

        {productDetails?.map((item, routeIndex) => (
          <div key={`route-${routeIndex}`}>
            <div className="container mt-3">
              <div className="row">
                <div className="col-12">
                  {item.packageList?.length > 0 && (
                    <div className="heading-title">
                      <span>{item.routeName}</span>
                      <Link to={`/tour/${item.routeId}`} target="_blank">
                        View All <i className="fas fa-arrow-right"></i>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {item.packageList?.length > 0 && (
              <div className="container">
                <div className="row">
                  <div className="col-12 wt-col position-relative">
                    {/* Horizontal scroll buttons preserved */}
                    <button
                      className="horizontal-scroll-btn horizontal-prev-btn hide-on-mobile"
                      onClick={() => scrollHorizontally(`scrollContainer-${routeIndex}`, 'left')}
                    >
                      <i className="bi bi-chevron-left"></i>
                    </button>

                    <div className="horizontal-scroll" id={`scrollContainer-${routeIndex}`}>
                      {item.packageList.map((packageItem, packageIndex) => {
                        const carouselId = `carousel-${routeIndex}-${packageIndex}`;

                        return (
                          <div className="mt-4" key={`package-${packageIndex}`}>
                            <div className="card card-wt-bo">
                              {/* Carousel component with all details as captions */}
                              <div id={carouselId} className="carousel slide" data-bs-ride="carousel">
                                {/* Images container */}
                                <div className="carousel-inner" style={{ borderRadius: '14px' }}>
                                  {/* First image (active by default) */}
                                  <div className="carousel-item active">
                                    <div className="position-relative">
                                      <img
                                        src={packageItem.imageList[0]?.coverImage}
                                        className="d-block w-100 img-route-card"
                                        height="450px" /* Increased image height further */
                                        alt="Package cover"
                                        onClick={(event) => onPackageClick(event, packageItem)}
                                      />
                                      <button className="save-offer-button">Save INR {packageItem.savePrices}</button>

                                      {/* Caption with package details */}
                                      <div className="carousel-caption d-md-block" style={{ background: 'linear-gradient(to top, rgba(0, 0, 0, 1) 50%, transparent 100%)', borderRadius: '8px', padding: '10px', bottom: '0px', left: '0%', right: '0%' }}>
                                        <h5 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '5px', color: '#ffffff' }}>
                                          {packageItem.packageName}
                                        </h5>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                          <span style={{ fontSize: '12px', color: '#ffffff' }}>
                                            {packageItem.packageDays} days & {packageItem.packageNight} nights
                                          </span>
                                          <span style={{ color: '#ffffff' }}>
                                            <i className="bi bi-star-fill" style={{ fontSize: '17px', color: '#fff099' }}></i> 4.8 (678)
                                          </span>
                                        </div>
                                        {/* <p style={{ fontSize: '14px', marginBottom: '5px', color: '#ffffff' }}>
                                          {packageItem?.routeDestination.map(route => route.destinationName).join(' ➔ ')}
                                        </p> */}

                                        <div style={{ marginBottom: '10px' }}>
                                          <b style={{ fontSize: '16px', color: '#fff099' }}>
                                            INR {new Intl.NumberFormat('en-IN').format(packageItem.packageWithDiscountPrices)}
                                          </b>
                                          <span style={{ textDecoration: 'line-through', marginLeft: '10px', color: '#ffffff' }}>
                                            INR {new Intl.NumberFormat('en-IN').format(packageItem.packagePrices)}
                                          </span>
                                          {/* <span style={{ color: '#fff099', marginLeft: '10px' }}>
                                            SAVE {new Intl.NumberFormat('en-IN').format(packageItem.savePrices)}
                                          </span> */}
                                        </div>

                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                          <a href="#" className="btn btn-outline-warning btn-color-call" style={{ color: '#090c08', borderColor: '#ffffff' }}>
                                            <i className="bi bi-telephone"></i>
                                          </a>
                                          {packageItem.packageType === 'Price' ? (
                                            <button
                                              type="button"
                                              className="btn btn-color"
                                              style={{ backgroundColor: '#ffbc23', border: 'none', color: '#2d2b29' }}
                                              onClick={() => handleBookOnline(packageItem)}
                                            >
                                              Book Now
                                            </button>
                                          ) : (
                                            <button
                                              type="button"
                                              className="btn btn-color"
                                              style={{ backgroundColor: '#fff099', border: 'none', color: '#2d2b29' }}
                                              data-bs-toggle="modal"
                                              data-bs-target="#exampleModal"
                                              onClick={() => requestCallBack(packageItem)}
                                            >
                                              Request Callback
                                            </button>
                                          )}

                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Additional images from subImageList */}
                                  {packageItem.imageList[0]?.subImageList && packageItem.imageList[0].subImageList.map((subImage, subIndex) => (
                                    <div
                                      className="carousel-item"
                                      key={`sub-image-${subIndex}`}
                                    >
                                      <div className="position-relative">
                                        <img
                                          src={subImage.subImage}
                                          className="d-block w-100 img-route-card"
                                          height="450px" /* Increased image height further */
                                          alt={`Package image ${subIndex + 1}`}
                                          onClick={(event) => onPackageClick(event, packageItem)}
                                        />
                                        <button className="save-offer-button">Save INR {packageItem.savePrices}</button>

                                        {/* Caption with package details - repeated on each slide */}
                                        <div className="carousel-caption d-md-block" style={{ background: 'linear-gradient(to top, rgba(0, 0, 0, 1) 50%, transparent 100%)', borderRadius: '8px', padding: '10px', bottom: '0px', left: '0%', right: '0%' }}>
                                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                            <span style={{ fontSize: '12px', color: '#ffffff' }}>
                                              {packageItem.packageDays} days & {packageItem.packageNight} nights
                                            </span>
                                            <span style={{ color: '#ffffff' }}>
                                              <i className="bi bi-star-fill" style={{ fontSize: '17px', color: '#fff099' }}></i> 4.8 (678)
                                            </span>
                                          </div>

                                          <h5 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '5px', color: '#ffffff' }}>
                                            {packageItem.packageName}
                                          </h5>

                                          <p style={{ fontSize: '14px', marginBottom: '5px', color: '#ffffff' }}>
                                            {packageItem?.routeDestination.map(route => route.destinationName).join(' ➔ ')}
                                          </p>

                                          <div style={{ marginBottom: '10px' }}>
                                            <b style={{ fontSize: '16px', color: '#fff099' }}>
                                              INR {new Intl.NumberFormat('en-IN').format(packageItem.packageWithDiscountPrices)}
                                            </b>
                                            <span style={{ textDecoration: 'line-through', marginLeft: '10px', color: '#ffffff' }}>
                                              INR {new Intl.NumberFormat('en-IN').format(packageItem.packagePrices)}
                                            </span>
                                            <span style={{ color: '#fff099', marginLeft: '10px' }}>
                                              SAVE {new Intl.NumberFormat('en-IN').format(packageItem.savePrices)}
                                            </span>
                                          </div>

                                          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                            <a href="#" className="btn btn-outline-warning btn-color-call" style={{ color: '#090c08', borderColor: '#ffffff' }}>
                                              <i className="bi bi-telephone"></i>
                                            </a>
                                            <button
                                              type="button"
                                              className="btn btn-color"
                                              style={{ backgroundColor: '#fff099', border: 'none', color: '#2d2b29' }}
                                              data-bs-toggle="modal"
                                              data-bs-target="#exampleModal"
                                              onClick={() => requestCallBack(packageItem)}
                                            >
                                              Request Callback
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                  {/* Last slide with call-to-action */}
                                  <div className="carousel-item">
                                    <div className="position-relative">
                                      <img
                                        src={MANALI}
                                        className="d-block w-100 img-route-card"
                                        height="450px" /* Increased image height further */
                                        alt="Call to action"
                                      />
                                      <div className="carousel-caption d-md-block" style={{ background: 'linear-gradient(to top, rgba(0, 0, 0, 1) 50%, transparent 100%)', borderRadius: '8px', padding: '10px', bottom: '0px', left: '0%', right: '0%' }}>
                                        <h5 style={{ fontWeight: 'bold', color: '#fff099' }}>SAVE INR {packageItem.savePrices}</h5>
                                        <h6 style={{ fontWeight: 'bold', color: '#ffffff' }}>on this trip</h6>
                                        <hr style={{ color: '#f37002' }} />
                                        <button
                                          className="btn btn-color-carousel"
                                          style={{ backgroundColor: '#fff099', color: '#2d2b29', padding: '8px 20px' }}
                                          data-bs-toggle="modal"
                                          data-bs-target="#exampleModal"
                                          onClick={() => requestCallBack(packageItem)}
                                        >
                                          Connect with an Expert
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Carousel control buttons preserved */}
                                <button
                                  className="carousel-control-prev"
                                  type="button"
                                  data-bs-target={`#${carouselId}`}
                                  data-bs-slide="prev"
                                >
                                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                  <span className="visually-hidden">Previous</span>
                                </button>
                                <button
                                  className="carousel-control-next"
                                  type="button"
                                  data-bs-target={`#${carouselId}`}
                                  data-bs-slide="next"
                                >
                                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                  <span className="visually-hidden">Next</span>
                                </button>
                              </div>
                            </div>

                            {/* Modal preserved but moved outside carousel */}
                            {isModalOpen && (
                              <div
                                className="modal fade"
                                id="exampleModal"
                                tabIndex="-1"
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                              >
                                <div className="modal-dialog modal-dialog-scrollable modal-down">
                                  <div className="modal-content modal-content-overflow">
                                    <div className="modal-header">
                                      <div className="container modal-heading-section">
                                        <div className="row d-flex flex-row">
                                          <div className=" col-3 me-1">
                                            <img
                                              src={packageItemInfo && packageItemInfo?.imageList[0]?.coverImage}
                                              alt=""
                                              className="rounded mx-auto d-block"
                                              width="50" height="50"
                                            />
                                          </div>
                                          <div className="col-9">
                                            <h5 className="card-text bold" style={{ fontSize: '12px' }}>
                                              {packageItemInfo?.packageName}
                                            </h5>
                                            <p className="card-text">
                                              <b className="me-2 package-title-prices">
                                                INR {packageItemInfo?.packageWithDiscountPrices || 0}
                                              </b>
                                              <span className="package-price-decoration me-1">
                                                INR {packageItemInfo?.packagePrices || 0}
                                              </span>
                                              <span className="title-prices">
                                                SAVE INR {packageItemInfo?.savePrices || 0}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <button
                                        type="button"
                                        className="customer-close-btn"
                                        onClick={handleCancel}
                                        data-bs-dismiss="modal"
                                      >
                                        &times;
                                      </button>
                                    </div>

                                    <div className="modal-body">
                                      <>
                                        <Backdrop
                                          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                                          open={loadingDetails}
                                        >
                                          <CircularProgress color="inherit" />
                                        </Backdrop>
                                        <form className="form-modal-wraaper mt-1">
                                          <div className="form-floating mb-3">
                                            <input
                                              type="text"
                                              className={`form-control ${errors.fullName ? 'is-invalid' : ''}`}
                                              placeholder="Full Name"
                                              value={fullName}
                                              onChange={(e) => handleChange('fullName', e.target.value)}
                                            />
                                            <label>Full Name *</label>
                                            {errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
                                          </div>
                                          <div className="form-floating mb-3">
                                            <input
                                              type="email"
                                              className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                              placeholder="name@example.com"
                                              value={email}
                                              onChange={(e) => handleChange('email', e.target.value)}
                                            />
                                            <label>Email* </label>
                                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                          </div>
                                          <div className="form-floating mb-3">
                                            <input
                                              type="text"
                                              className={`form-control ${errors.mobileNo ? 'is-invalid' : ''}`}
                                              placeholder="+91 xxx xxxx xxx"
                                              value={mobileNo}
                                              pattern="\d{10}"
                                              minLength={10}
                                              maxLength={10}
                                              onChange={(e) => handleChange('mobileNo', e.target.value)}
                                            />
                                            <label>Mobile No.*</label>
                                            {errors.mobileNo && <div className="invalid-feedback">{errors.mobileNo}</div>}
                                          </div>

                                          <div className="row align-self-center">
                                            <div className="col-md-6 mt-1">
                                              <div className="form-floating mb-3">
                                                <input
                                                  type="date"
                                                  className={`form-control ${errors.travelDate ? 'is-invalid' : ''}`}
                                                  placeholder="Travel Date"
                                                  value={travelDate}
                                                  min={new Date().toISOString().split('T')[0]}
                                                  max={new Date(new Date().getFullYear() + 1, 11, 31).toISOString().split('T')[0]}
                                                  onChange={(e) => handleChange('travelDate', e.target.value)}
                                                />
                                                <label>Travel Date*</label>
                                                {errors.travelDate && <div className="invalid-feedback">{errors.travelDate}</div>}
                                              </div>
                                            </div>
                                            <div className="col-md-6 mt-1">
                                              <div className="form-floating mb-3">
                                                <input
                                                  type="number"
                                                  className={`form-control ${errors.travelCount ? 'is-invalid' : ''}`}
                                                  placeholder="Traveller Count"
                                                  value={travelCount}
                                                  onChange={(e) => handleChange('travelCount', e.target.value)}
                                                  min={1}
                                                  max={5}
                                                />
                                                <label>Traveller Count*</label>
                                                {errors.travelCount && <div className="invalid-feedback">{errors.travelCount}</div>}
                                              </div>
                                            </div>
                                            <div className="form-floating mb-3">
                                              <textarea
                                                className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                                                placeholder="Message"
                                                value={message}
                                                rows={4}
                                                onChange={(e) => handleChange('message', e.target.value)}
                                                style={{ minHeight: '100px' }}
                                              />
                                              <label className="message-placeholder">Your Requirements *</label>
                                              {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                                            </div>
                                          </div>
                                        </form>
                                      </>
                                    </div>
                                    <hr className="mt-margin" />
                                    <div className="modal-footer">
                                      <button
                                        type="button"
                                        className="btn btn-color bt-width"
                                        style={{ backgroundColor: '#fff099', border: 'none' }}
                                        onClick={sendEnquiry}
                                      >
                                        Connect with an Expert
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>

                    {/* Right scroll button preserved */}
                    <button
                      className="horizontal-scroll-btn horizontal-next-btn hide-on-mobile"
                      onClick={() => scrollHorizontally(`scrollContainer-${routeIndex}`, 'right')}
                    >
                      <i className="bi bi-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </>
      <div className="mt-5">
        <Footer />
      </div>
      {
        isModelSign && (
          <>
            <div>
              <SignIn isModelSign={isModelSign} closePopup={handleClose} userDetais={onSignInUser}

                isBookOnline={true} packageItemInfo={packageData}></SignIn>

            </div>
          </>
        )
      }
    </>
  );

}

export default HomeComponent;